module.exports = __webpack_public_path__ + "img/bof.3c1622eb.png";